import React, { useEffect, useState } from "react";
import Contract from "../../../../individual/Contract/Contract";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createContract,
  updateContract,
} from "../../../../../redux/contractSlice/contractSlice";
import notify from "../../../../../hooks/useNotifaction";

export default function ContractReview({
  contract,
  maintenanceItems,
  terms,
  selectedBranch,
  selectedCompany,
  setContract,
  isSingleBranchCompany, // إضافة البروب
  withoutQuantities,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { status, error } = useSelector((state) => state.contract);
  const [loading, setLoading] = useState(false);
  const { ContractId } = useParams();

  const prepareContractData = () => ({
    branch_id: selectedBranch?.value,
    start_date: contract.start_date,
    end_date: contract.end_date,
    value: contract.value,
    maintenance_visits: Number(contract.maintenance_visits),
    payment_type: contract.payment_type,
    single_branch_company: isSingleBranchCompany,
    ...(contract.first_party && { first_party: contract.first_party }),
    ...(contract.second_party && { second_party: contract.second_party }),
    introduction: contract.introduction?.trim() || "",
    installment_count:
      contract.payment_type === "installments"
        ? contract.installment_count
        : undefined,
    first_payment:
      contract.payment_type === "installments"
        ? contract.first_payment
        : undefined,
    second_payment:
      contract.payment_type === "installments"
        ? contract.second_payment
        : undefined,
    second_payment_date:
      contract.payment_type === "installments"
        ? contract.second_payment_date
        : undefined,
    maintenance_items: maintenanceItems.map((item) => item.description),
    terms: contract.terms.map((term) => ({
      title: term.title,
      description: term.description,
    })),
    clauses: maintenanceItems?.map((item) => {
      const clause = { item: item.item };

      // ✅ فقط إضافة quantity لو الـ checkbox مش checked ولو فيه قيمة
      if (!withoutQuantities) {
        clause.quantity = item.quantity || "";
      }

      return clause;
    }),
  });

  const validateContract = () => {
    const contractData = prepareContractData();
    const requiredFields = [
      {
        key: "branch_id",
        value: contractData.branch_id,
        message: "يرجى اختيار الفرع",
      },
      {
        key: "start_date",
        value: contractData.start_date,
        message: "يرجى تحديد تاريخ البداية",
      },
      {
        key: "end_date",
        value: contractData.end_date,
        message: "يرجى تحديد تاريخ النهاية",
      },
      {
        key: "value",
        value: contractData.value,
        message: "يرجى إدخال قيمة العقد",
      },
      {
        key: "maintenance_visits",
        value: contractData.maintenance_visits,
        message: "يرجى تحديد عدد زيارات الصيانة",
      },
      {
        key: "introduction",
        value: contractData.introduction,
        message: "يرجى إدخال مقدمة العقد",
      },
      // ملاحظة: first_party و second_party اختيارية (optional)
    ];

    for (const field of requiredFields) {
      if (!field.value) {
        notify(field.message, "error");
        return false;
      }
    }

    // if (contractData.payment_type === "installments") {
    //   const installmentFields = [
    //     { key: "installment_count", value: contractData.installment_count, message: "يرجى تحديد عدد الأقساط" },
    //     { key: "first_payment", value: contractData.first_payment, message: "يرجى إدخال الدفعة الأولى" },
    //     { key: "second_payment", value: contractData.second_payment, message: "يرجى إدخال الدفعة الثانية" },
    //     { key: "second_payment_date", value: contractData.second_payment_date, message: "يرجى تحديد تاريخ الدفعة الثانية" },
    //   ];

    //   for (const field of installmentFields) {
    //     if (!field.value) {
    //       notify(field.message, "error");
    //       return false;
    //     }
    //   }
    // }

    if (maintenanceItems.length === 0) {
      notify("يجب إضافة عناصر الصيانة", "error");
      return false;
    }

    if (terms.length === 0) {
      notify("يجب إضافة شروط العقد", "error");
      return false;
    }

    return true;
  };

  const handleContractSubmission = async () => {
    if (!ContractId) {
      if (!validateContract()) {
        return;
      }
    }

    setLoading(true);
    try {
      const contractData = prepareContractData();

      if (!ContractId) {
        // CREATE
        await dispatch(createContract(contractData)).unwrap();
        notify("تم حفظ العقد بنجاح", "success");
      } else {
        // UPDATE
        await dispatch(
          updateContract({ id: ContractId, data: contractData }),
        ).unwrap();
        notify("تم تحديث العقد بنجاح", "success");
      }

      // ✅ هنا بقى التحويل
      navigate("/contracts");
    } catch (err) {
      notify(err?.message || "حدث خطأ أثناء إضافة العقد", "error");
      console.error("Error adding contract:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="carousel-item">
      <div className="container mt-5 pt-3">
        <h3 className="text-center">مراجعة العقد</h3>
        <Contract
          selectedCompany={selectedCompany}
          selectedBranch={selectedBranch}
          contract={contract}
          isSingleBranchCompany={isSingleBranchCompany} // تمرير البروب
        />
      </div>
      <div className="d-flex justify-content-between mx-5 my-3">
        <button
          className="btn btn-outline-secondary"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
          disabled={loading}
        >
          السابق
        </button>
        <button
          className="btn btn-success"
          onClick={handleContractSubmission}
          disabled={loading}
        >
          {loading ? "جاري الحفظ..." : "حفظ العقد"}
        </button>
      </div>
    </div>
  );
}
